export function PreferencesFormSkeleton() {
  return (
    <div className="h-[calc(100vh-13.5rem)] gap-2 p-2 animate-pulse">
      <div className="h-8 w-48 bg-neutral-200 rounded m-2" />
      <div className="flex flex-col gap-6 h-[90%] justify-between">
        <div className="max-h-full p-2 overflow-y-auto">
          <div className="flex flex-col sm:flex-row w-full justify-start gap-6 mt-6">
            <div className="flex flex-col gap-2">
              <div className="w-32 h-32 bg-neutral-200 rounded-full" />
            </div>
            <div className="flex flex-col gap-5 min-w-80">
              <div className="space-y-2">
                <div className="h-4 w-20 bg-neutral-200 rounded" />
                <div className="h-10 w-full bg-neutral-200 rounded" />
              </div>
              <div className="space-y-2">
                <div className="h-4 w-32 bg-neutral-200 rounded" />
                <div className="h-10 w-full bg-neutral-200 rounded" />
              </div>
            </div>
          </div>
          <div className="mt-5 space-y-2">
            <div className="h-4 w-16 bg-neutral-200 rounded" />
            <div className="h-10 w-full bg-neutral-200 rounded" />
          </div>
        </div>
        <div className="flex flex-row justify-end">
          <div className="h-10 w-24 bg-neutral-200 rounded" />
        </div>
      </div>
    </div>
  )
}
